/**
 * 新字典系统 API (JSON 多语言字典)
 */
import request from '@/utils/request';

const baseURLAdmin = process.env.VUE_APP_ADMIN;

// ===================== 字典大类 (DictType) =====================

/**
 * 分页查询字典大类列表
 */
export const dictTypePage = (data) => {
  return request({
    method: 'post',
    data,
    url: '/new-dict/type/page',
    baseURL: baseURLAdmin
  });
};

/**
 * 获取全量字典大类列表（用于下拉选择）
 */
export const dictTypeList = (keyword) => {
  return request({
    method: 'get',
    url: '/new-dict/type/list',
    params: { keyword },
    baseURL: baseURLAdmin
  });
};

/**
 * 获取单个字典大类详情
 */
export const dictTypeDetail = (id) => {
  return request({
    method: 'get',
    url: `/new-dict/type/${id}`,
    baseURL: baseURLAdmin
  });
};

/**
 * 保存或修改字典大类
 */
export const dictTypeSave = (data) => {
  return request({
    method: 'post',
    data,
    url: '/new-dict/type',
    baseURL: baseURLAdmin
  });
};

/**
 * 删除字典大类
 */
export const dictTypeDelete = (id) => {
  return request({
    method: 'delete',
    url: `/new-dict/type/${id}`,
    baseURL: baseURLAdmin
  });
};

// ===================== 字典数据明细 (DictData) =====================

/**
 * 分页查询字典数据明细
 */
export const dictDataPage = (data) => {
  return request({
    method: 'post',
    data,
    url: '/new-dict/data/page',
    baseURL: baseURLAdmin
  });
};

/**
 * 获取指定类型下的明细数据列表
 */
export const dictDataList = (dictType) => {
  return request({
    method: 'get',
    url: '/new-dict/data/list',
    params: { dictType },
    baseURL: baseURLAdmin
  });
};

/**
 * 保存或修改字典数据明细
 */
export const dictDataSave = (data) => {
  return request({
    method: 'post',
    data,
    url: '/new-dict/data',
    baseURL: baseURLAdmin
  });
};

/**
 * 获取单个字典数据明细详情
 */
export const dictDataDetail = (id) => {
  return request({
    method: 'get',
    url: `/new-dict/data/${id}`,
    baseURL: baseURLAdmin
  });
};

/**
 * 删除字典数据明细项
 */
export const dictDataDelete = (id) => {
  return request({
    method: 'delete',
    url: `/new-dict/data/${id}`,
    baseURL: baseURLAdmin
  });
};
